import Quill from "quill";
import Fullscreen from './fullScreen'
import Emoji from './emoji'
Quill.register('modules/fullscreen', Fullscreen)
Quill.register('modules/emoji', Emoji)

// const Base = Quill.import('blots/inline');
// class MentionBlot extends Base {
//     static create(html) {
//         const node = super.create('span');
//         node.innerHTML = html
//         return node;
//     }
// }
// MentionBlot.blotName = 'usermention';
// MentionBlot.tagName = 'aumention';
// Quill.register(MentionBlot);

const Parchment = Quill.imports.parchment;
class EmbedTag extends Parchment.Embed {
    static create(value) {
        // 正常span标签就直接返回node对象
        if (value.nodeName === 'SPAN') {
            return value;
        }
        // let html = `<span class="at"  msgType="at" contenteditable="false" style="color: rgb(64, 158, 255)" uid="${id}">@${id == 'all' ? '所有人' : name} </span>`
        const node = super.create(value);
        node.contentEditable = 'false';
        this.contentNode = document.createElement('span');
        this.contentNode.classList.add('at');
        this.contentNode.setAttribute("msgType", 'at')
        this.contentNode.style.color = 'rgb(64, 158, 255)'
        this.contentNode.style.display = 'inline'
        // this.contentNode.setAttribute("style", {'color': 'rgb(64, 158, 255)', 'display': 'inline'})
        this.contentNode.setAttribute("uid", value.id)
        this.contentNode.innerHTML = `@${value.name}&nbsp;`;
        node.appendChild(this.contentNode);
        return node;
    }
    static value(node) {
        return node;
    }
}
class emojiTag extends Parchment.Embed {
    static create(value) {


        // <img msgType="emoji" code="00017" tip="篮球" style="width: 20px;height: 20px;vertical-align:middle" src="http://192.168.12.107:9000//message/icon/get/00017"/>
        const node = super.create(value);
        node.contentEditable = 'false';
        this.contentNode = document.createElement('img');
        this.contentNode.setAttribute("msgType", 'emoji')
        this.contentNode.style.width = '20px'
        this.contentNode.style.height = '20px'
        this.contentNode.style.verticalAlign = 'middle'
        this.contentNode.setAttribute("src", value.src)
        node.appendChild(this.contentNode);
        return node;
    }
    static value(node) {
        return node;
    }
}

EmbedTag.blotName = "atTag"
EmbedTag.tagName = "SPAN"
EmbedTag.className = "customTag"; // 这个一定要加，不然富文本中其他样式用到了span标签的也会读取这个自定义blot,比如会导致我背景颜色取消的时候找不到原始方法报错。。。。。

emojiTag.blotName = "emojiTag"
emojiTag.tagName = "SPAN"
emojiTag.className = "customTag";

Quill.register(EmbedTag);
Quill.register(emojiTag);

class AppPanelEmbed extends Parchment.Embed {
    static  create(value) {
      const node = super.create(value);
      node.setAttribute('contenteditable','false');
      node.setAttribute('width','100%');
      // 设置自定义html
      node.innerHTML = this.transformValue(value);
      return node;
    }

    static transformValue(value) {
      let handleArr = value.split('\n');
      handleArr = handleArr.map( (e) => {return e.replace(/^[\s]+/, '').replace(/[\s]+$/, '')});
      return handleArr.join('')
    }

    // 返回节点自身的value值
    static value(node) {
      return node.innerHTML;
    }
  }
  // blotName
  AppPanelEmbed.blotName = 'AppPanelEmbed';
  // class名将用于匹配blot名称
  AppPanelEmbed.className = 'myhtml';
  // 标签类型自定义
  AppPanelEmbed.tagName = 'div';
  Quill.register(AppPanelEmbed, true);
export default Quill